


















































import { Component, Prop } from "vue-property-decorator";
import DataTable from "@/shared/components/data-table.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import PlanosAba from "../tables/PlanosAba.vue";
import Confirm from "@/shared/components/confirm.vue";
import AdicionarMotivoInatividade from "../modals/AdicionarMotivoInatividade.vue";

import {
  ConsultoresService,
  StatusConsultor,
} from "@/services/consultores.service";

@Component({
  components: {
    DataTable,
    Confirm,
    PlanosAba,
    AdicionarMotivoInatividade,
  },
})
export default class AtivarInativarConsultor extends mixins(GlobalMixin) {
  @Prop() idConsultor!: string;
  loading = false;
  showSucess?: boolean = false;
  showError?: boolean = false;
  ativo = "";

  statusConsultor: StatusConsultor = {
    ativo: null,
    motivoInatividade: "",
  };

  mounted() {
    this.fetchStatusConsultor();
  }

  async fetchStatusConsultor() {
    this.loading = true;
    try {
      this.statusConsultor = await ConsultoresService.ObterStatusConsultor(
        Number(this.idConsultor)
      );
      this.ativo = this.statusConsultor.ativo ? "Ativo" : "Inativo";
      this.loading = false;
    } finally {
      this.loading = false;
    }
  }

  async AtivarInativar() {
    let res = true;
    if (this.statusConsultor.ativo) {
      const modal = this.$refs
        .adicionarMotivoInatividade as AdicionarMotivoInatividade;
      res = await modal.adicionarMotivo(Number(this.idConsultor));
    } else {
      this.startLoader();
      await ConsultoresService.AtivarInativar(
        Number(this.idConsultor),
        this.statusConsultor!.motivoInatividade
      ).finally(this.stopLoader);
    }
    if (res) {
      await this.fetchStatusConsultor();
      this.$emit("statusAlterado");
      
      this.showSucess = true;
      setTimeout(this.fechaAlertaStatusSucess, 5000);
    }
  }

  fechaAlertaStatusSucess() {
    this.showSucess = false;
  }
}
